import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import { FC } from 'react';
import { Styled, ShopByTaxonProps, i18nCategoryName } from '.';
import { useI18n } from 'contexts/i18n';

const ShopByTaxon: FC<ShopByTaxonProps> = ({ taxon, size = 'large' }) => {
  const router = useRouter();
  const i18n = useI18n();

  return (
    <Styled.ShopByCategoryContainer
      onClick={() => router.push(`/category/${taxon.permalink}`)}
    >
      <Styled.CategoryNameWrapper
        textAlign={taxon.h3TextPosition || taxon.h1TextPosition || 'left'}
      >
        <Styled.CategoryName
          fontSize={taxon.h3Text ? 'small' : 'large'}
          className="homepage-promotional-taxon-gtm"
        >
          {i18nCategoryName(i18n, taxon.h3Text, taxon.h1Text)}
        </Styled.CategoryName>
      </Styled.CategoryNameWrapper>

      <Styled.MyImage $size={size}>
        <Image
          src={taxon.imageUrl}
          className="homepage-promotional-taxon-gtm"
          alt="Category"
          layout="fill"
          objectFit="cover"
          placeholder="blur"
          blurDataURL="data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImciPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjY2JjYmNiIiBvZmZzZXQ9IjIwJSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2Y5ZjlmOSIgb2Zmc2V0PSI1MCUiIC8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNjYmNiY2IiIG9mZnNldD0iNzAlIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3Qgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIGZpbGw9IiNjYmNiY2IiIC8+CiAgPHJlY3QgaWQ9InIiIHdpZHRoPSI3MDAiIGhlaWdodD0iNDc1IiBmaWxsPSJ1cmwoI2cpIiAvPgogIDxhbmltYXRlIHhsaW5rOmhyZWY9IiNyIiBhdHRyaWJ1dGVOYW1lPSJ4IiBmcm9tPSItNzAwIiB0bz0iNzAwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+Cjwvc3ZnPg=="
        />
        {(taxon.h3Text || taxon.h1Text) && (
          <Styled.ShopNowButton className="homepage-promotional-taxon-gtm">
            {taxon?.ctaText ?? i18n['Shop Now']}
          </Styled.ShopNowButton>
        )}
      </Styled.MyImage>
    </Styled.ShopByCategoryContainer>
  );
};

export default ShopByTaxon;
